
import http from '@/http/http'
const PREFIX = 'api/identity/my-profile';
const PRE = 'api/deer/my-profile';


export function getMyProfile() {
  return http({
    url: PRE
  })
}

export function putMyProfile(data) {
  return http({
    url: PRE,
    method: 'put',
    data
  })
}

export function changePassword(data) {
  return http({
    url: PREFIX + '/change-password',
    method: 'post',
    data
  })
}

export function getMyProfilePermissions() {
  return http({
    url: PRE + '/get-permissions'
  })
}

export function getMyProfileTenants() {
  return http({
    url: PRE + '/get-tenants'
  })
}